module.exports = {
	"_args": [
		[
			"elliptic@^6.0.0",
			"/var/lib/jenkins/jobs/mattermost-platform-release/workspace/src/github.com/mattermost/platform/webapp/node_modules/browserify-sign"
		]
	],
	"_from": "elliptic@>=6.0.0 <7.0.0",
	"_id": "elliptic@6.2.3",
	"_inCache": true,
	"_installable": true,
	"_location": "/elliptic",
	"_nodeVersion": "5.4.1",
	"_npmUser": {
		"email": "fedor@indutny.com",
		"name": "indutny"
	},
	"_npmVersion": "3.3.12",
	"_phantomChildren": {},
	"_requested": {
		"name": "elliptic",
		"raw": "elliptic@^6.0.0",
		"rawSpec": "^6.0.0",
		"scope": null,
		"spec": ">=6.0.0 <7.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/browserify-sign",
		"/create-ecdh"
	],
	"_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-6.2.3.tgz",
	"_shasum": "18e46d7306b0951275a2d42063270a14b74ebe99",
	"_shrinkwrap": null,
	"_spec": "elliptic@^6.0.0",
	"_where": "/var/lib/jenkins/jobs/mattermost-platform-release/workspace/src/github.com/mattermost/platform/webapp/node_modules/browserify-sign",
	"author": {
		"email": "fedor@indutny.com",
		"name": "Fedor Indutny"
	},
	"bugs": {
		"url": "https://github.com/indutny/elliptic/issues"
	},
	"dependencies": {
		"bn.js": "^4.0.0",
		"brorand": "^1.0.1",
		"hash.js": "^1.0.0",
		"inherits": "^2.0.1"
	},
	"description": "EC cryptography",
	"devDependencies": {
		"coveralls": "^2.11.3",
		"istanbul": "^0.4.2",
		"jscs": "^2.9.0",
		"jshint": "^2.6.0",
		"mocha": "^2.1.0"
	},
	"directories": {},
	"dist": {
		"shasum": "18e46d7306b0951275a2d42063270a14b74ebe99",
		"tarball": "https://registry.npmjs.org/elliptic/-/elliptic-6.2.3.tgz"
	},
	"files": [
		"lib"
	],
	"gitHead": "c32f20b22b420eb6af3c6dda28963deb7facf823",
	"homepage": "https://github.com/indutny/elliptic",
	"keywords": [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	],
	"license": "MIT",
	"main": "lib/elliptic.js",
	"maintainers": [
		{
			"email": "fedor@indutny.com",
			"name": "indutny"
		}
	],
	"name": "elliptic",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/indutny/elliptic.git"
	},
	"scripts": {
		"coverage": "npm run unit --coverage",
		"coveralls": "npm run coverage && cat ./coverage/lcov.info | coveralls",
		"jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/*.js",
		"jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/*.js",
		"lint": "npm run jscs && npm run jshint",
		"test": "npm run lint && npm run unit",
		"unit": "istanbul test _mocha --reporter=spec test/*-test.js"
	},
	"version": "6.2.3"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/elliptic/package.json
 ** module id = 1755
 ** module chunks = 0
 **/